import React, { Component } from 'react'
import { Card, Col, Row } from 'react-bootstrap';
import Image from "next/image";

const small_image = (front_end_image, partner) => {
  if (partner === "parikrma") {
    return (
      <Col md="4">
        <div className="mr0 d2d-card-list">
          <div className="d2d-card-body">
            <div>
              <Image
                src={`${front_end_image}parikrma-child-web.jpg`}
                alt="Parikrma"
                width="300"
                height="300"
                style={{
                  maxWidth: "100%",
                  height: "auto"
                }} />
            </div>
          </div>
        </div>
      </Col>
    );  
  } else if (partner === "nbtgiftaclassroom") {
    return (
      <Col md="4">
        <div className="mr0 d2d-card-list">
          <div className="d2d-card-body">
            <div>
              <Image
                src={`${front_end_image}nbtgiftaclassroom_img.jpg`}
                alt="nbtgiftaclassroom"
                width="300"
                height="300"
                style={{
                  maxWidth: "100%",
                  height: "auto"
                }} />
            </div>
          </div>
        </div>
      </Col>
    );
  } else {
    return (
      <Col md="4">
        <div className="mr0 d2d-card-list">
          <div className="d2d-card-body">
            <div>
              <Image
                src={`${front_end_image}device-to-dream-girl.jpg`}
                alt="Device To Dream Budli"
                width="300"
                height="300"
                style={{
                  maxWidth: "100%",
                  height: "auto"
                }} />
            </div>
          </div>
        </div>
      </Col>
    );
  }
};

class D2dInnerBanner extends Component {
    render() {
        const s3_front_end_image =
          "https://budlisell.s3.ap-south-1.amazonaws.com/assets/themes/forntend/default/img/";
        const { partner, partnerContent } = this.props;
      return (
        <Row className="justify-content-md-center">
          {!partner ? (
            <>
              <Col md="8">
                <div className="mr0 d2d-card-list">
                  <div className="d2d-card-body">
                    <div>
                      <Image
                        src={`${s3_front_end_image}device-to-dream-web.jpg`}
                        alt="Budli Device To Dream Programme"
                        width="800"
                        height="300"
                        className='w-100 h-auto'
                        />
                    </div>
                  </div>
                </div>
              </Col>
              <Col md="4">
                <div className="mr0 d2d-card-list">
                  <div className="d2d-card-body">
                    <div>
                      <Image
                        src={`${s3_front_end_image}device-to-dream-girl.jpg`}
                        alt="Device To Dream Budli"
                        width="300"
                        height="300"
                        style={{
                          maxWidth: "100%",
                          height: "auto"
                        }} />
                    </div>
                  </div>
                </div>
              </Col>
            </>
          ) : (
            <>
              {partnerContent && partnerContent.banner ? (
                <Col md="8">
                  <div className="mr0 d2d-card-list">
                    <div className="d2d-card-body">
                      <div>
                        <Image
                          src={partnerContent.banner}
                          alt="Budli Device To Dream Programme"
                          width="800"
                          height="300"
                          className='w-100 h-auto'
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              ) : (
                <Col md="8">
                  <div className="mr0 d2d-card-list">
                    <div className="d2d-card-body">
                      <div>
                        <Image
                          src={`${s3_front_end_image}device-to-dream-web.jpg`}
                          alt="Budli Device To Dream Programme"
                          width="800"
                          height="300"
                          className='w-100 h-auto'
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              )}
              {small_image(s3_front_end_image, partner)}
            </>
          )}
        </Row>
      );
    }
}

export default D2dInnerBanner;